import { fetchAsync, postAsync } from 'common/fetch'
import { IAddressRequest, IBuyerProfileData } from 'types/accountTypes'
import { IUserProfile, ISaveUserProfileRequest } from 'types/userTypes'

export const getAccountSettings = async () => {
  return postAsync<IBuyerProfileData>(`/api/v1/account/GetAccountSettings`)
}

export const saveAddress = async (request: IAddressRequest) => {
  return postAsync<number>(`/api/v1/account/SaveAddress`, {
    body: request
  })
}

export const logoutCarfax = async (): Promise<boolean> => {
  return postAsync<boolean>('/external/LogOutCarfaxConnect')
}

export const saveUserProfile = async (userProfile: ISaveUserProfileRequest): Promise<number> => {
  return postAsync<number>(`/api/v1/account/SaveUserProfile`, {
    body: userProfile
  })
}

export const getBuyersByCurrentUser = async (): Promise<any[]> => {
  return postAsync<any[]>(`/api/colisting/GetBuyersByCurrentUser`)
}
